import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
var _excluded = ["label", "classNameLabel", "icon", "selected", "isDark", "dark", "size", "className", "style", "value", "disabled", "htmlProps", "children"],
  _excluded2 = ["component"];
import { Fragment } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import getDefaultIconPropValues from "../helpers/getDefaultIconPropValues";
import parseClassnames from "../helpers/parseClassnames";
import ResponsiveText from "../ResponsiveText";
import { TAB_CLASSNAMES_BY_SIZE } from "./classnames";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Tab(_ref) {
  var label = _ref.label,
    classNameLabel = _ref.classNameLabel,
    iconProp = _ref.icon,
    selected = _ref.selected,
    isDark = _ref.isDark,
    dark = _ref.dark,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    style = _ref.style,
    value = _ref.value,
    disabled = _ref.disabled,
    htmlProps = _ref.htmlProps,
    children = _ref.children,
    tabProps = _objectWithoutProperties(_ref, _excluded);
  var _getDefaultIconPropVa = getDefaultIconPropValues(iconProp, size === 's' ? 16 : 24),
    Icon = _getDefaultIconPropVa.component,
    icon = _objectWithoutProperties(_getDefaultIconPropVa, _excluded2);
  return /*#__PURE__*/_jsxs(_StyledButton, _objectSpread(_objectSpread(_objectSpread({
    type: "button",
    className: parseClassnames(className, cn('button-base relative', TAB_CLASSNAMES_BY_SIZE[size], _defineProperty(_defineProperty(_defineProperty({}, isDark || dark ? 'text-gray-main hover:text-base-lighter' : 'text-gray-dark-56 hover:text-base-lighter', !selected), isDark || dark ? 'text-secondary-main' : 'text-primary-main', selected), 'cursor-not-allowed', disabled))),
    disabled: disabled
  }, htmlProps), tabProps), {}, {
    children: [label || Icon ? /*#__PURE__*/_jsxs(Fragment, {
      children: [Icon && /*#__PURE__*/_jsx(Icon, {
        size: icon.size,
        className: cn({
          'fill-current': icon.hasFill,
          'stroke-current': icon.hasStroke
        }, 'mr-8'),
        ignoreColor: true
      }), label && /*#__PURE__*/_jsx(ResponsiveText, {
        text: label,
        className: classNameLabel
      })]
    }) : children, /*#__PURE__*/_jsx(_StyledDiv, {
      className: cn('absolute bottom-0 inset-x-0 w-full rounded-5', size === 's' ? 'h-2' : 'h-4', isDark || dark ? 'bg-secondary-main' : 'bg-primary-main', selected ? 'opacity-1' : 'opacity-0')
    })]
  }));
}
export default Tab;
var _StyledButton = /*#__PURE__*/_styled("button")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n        transition: ", ";\n      "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition(['color', 'opacity']);
});
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  componentId: "sc-1ey1pdb-0"
})(["\n          transition: ", ";\n        "], function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition('opacity');
});